import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatCurrency } from '@angular/common';

@Pipe({
  name: 'localizedCurrency',
  pure: false,
  standalone: true,
})
export class LocalCurrencyPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: number): string {
    return formatCurrency(value, this.translate.getCurrentLang(), '€', 'EUR');
  }
}
